export let lang = "en";
export let isTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;

export function setLang(langToSet){
    lang = langToSet;
}